import { render, staticRenderFns } from "./GenerateChunks.vue?vue&type=template&id=cbe946ac"
import script from "./GenerateChunks.vue?vue&type=script&lang=js"
export * from "./GenerateChunks.vue?vue&type=script&lang=js"
import style0 from "./GenerateChunks.vue?vue&type=style&index=0&id=cbe946ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports